"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultProductTablePriceInfo = void 0;
var _cbaPriceInfo = require("../theming/cba/cbaPriceInfo");
var _defaultPriceInfo = require("./defaultPriceInfo");
var DefaultProductTablePriceInfo = exports.DefaultProductTablePriceInfo = {
  "default": _defaultPriceInfo.DefaultPriceInfo,
  cba: _cbaPriceInfo.CbaPriceInfo
};